module.exports = __webpack_public_path__ + "img/762-6e17f2.png";